module.exports = __webpack_public_path__ + "assets/img/sta.9a9a1bfa.webp";